import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
import Chatbot from '../com/Chatbot';
import { ArrowLeft, LayoutDashboard } from 'lucide-react';


const Nav = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/compare');  // Go back to the previous route
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 h-16">
      <div className="max-w-7xl mx-auto px-4 h-full">
        <div className="flex justify-between items-center h-full">
          {/* Back Button */}
          <button
            onClick={handleBack}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 p-2 rounded-lg"
          >
            <ArrowLeft size={20} />
            <span className="font-medium">Back</span>
          </button>

          {/* Dashboard Link */}
          <a
            href="/"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200"
          >
            <LayoutDashboard size={20} />
            <span className="font-medium">Dashboard</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

const Compres = () => {
  const { state } = useLocation(); // Get the state from the previous page
  const [response, setResponse] = useState("");
  const result = state?.result;
  const parsedResult = result ? JSON.parse(result) : null;

  useEffect(() => {
    if (result) {
      setResponse(result); 
    }
  }, [result]);
  const formatTextWithBold = (text) => {
        return text
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') 
          .replace(/\n/g, '<br/>'); 
      };

  return (
        <>
        <Nav/>
        <div className="relative">
          {/* Product Comparison Result Card */}
          <div className="absolute inset-x-0 top-1/4 mx-auto w-2/3 bg-blue-50 p-6 rounded-lg border border-blue-200 shadow-md">
            <h3 className="text-lg font-bold text-blue-600 mb-4 text-center">
              Product Comparison Result
            </h3>
            {parsedResult ? (
              <div>
                {/* Display parsed result data */}
                {Object.entries(parsedResult).map(([key, value]) => (
                  <div key={key} className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">{key}</h2>
                    <p
                      className="text-gray-700 whitespace-pre-wrap"
                      dangerouslySetInnerHTML={{ __html: formatTextWithBold(value) }}
                    ></p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-red-400 text-center">
                No data available. Please try again.
              </p>
            )}
          </div>

        <div>
          <Chatbot/>
       </div>
     </div>
    </>
  );
};

export default Compres;




